import { render, staticRenderFns } from "./FrrProfiles.vue?vue&type=template&id=63bb2be4&scoped=true&"
import script from "./FrrProfiles.vue?vue&type=script&lang=js&"
export * from "./FrrProfiles.vue?vue&type=script&lang=js&"
import style0 from "./FrrProfiles.sass?vue&type=style&index=0&id=63bb2be4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb2be4",
  null
  
)

export default component.exports